import { render, staticRenderFns } from "./PaymentError.vue?vue&type=template&id=4b2220d7&"
import script from "./PaymentError.vue?vue&type=script&lang=js&"
export * from "./PaymentError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports